import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FloatLabel} from 'primeng/floatlabel';
import {InputText} from 'primeng/inputtext';
import {Button} from 'primeng/button';

@Component({
	selector: 'app-mailbox-form',
	standalone: true,
	imports: [
		FloatLabel,
		FormsModule,
		InputText,
		ReactiveFormsModule,
		Button
	],
	template: `
		<form [formGroup]="form" class="p-fluid">
			<div class="flex flex-column gap-3">
				<!-- NAME -->
				<div class="flex flex-column">
					<p-floatlabel variant="on">
						<input pInputText
							   formControlName="mailbox_name"
							   autocomplete="off"
							   fluid/>
						<label for="mailbox_name">Nome Mailbox</label>
					</p-floatlabel>
				</div>

				<!-- ADDRESS -->
				<div class="flex flex-column">
					<p-floatlabel variant="on">
						<input pInputText
							   formControlName="mailbox_address"
							   autocomplete="off"
							   fluid/>
						<label for="mailbox_address">Indirizzo email</label>
					</p-floatlabel>
					<small class="text-500">Inserire l'indirizzo email dal quale generare i Ticket</small>
				</div>
			</div>
		</form>
		@if (showSubmit) {
			<div class="flex justify-content-end">
				<p-button (onClick)="saveRequested.emit()">Salva</p-button>
			</div>
		}
	`
})
export class MailboxFormComponent implements OnInit {
	@Input({ required: true }) form!: FormGroup;
	@Input() showSubmit = false;
	@Output() saveRequested = new EventEmitter<void>();

	ngOnInit() {
		if (this.showSubmit) this.form.reset();
	}
}
